import { useEffect, useRef } from 'react';

const CodeInput = ({ digits, onChange, autoFocus = false, getAriaLabel }) => {
  const codeInputsRef = useRef([]);

  useEffect(() => {
    if (autoFocus) {
      codeInputsRef.current?.[0]?.focus();
    }
  }, [autoFocus]);

  const handleCodeChange = (index, value) => {
    const cleaned = value.replace(/\D/g, '').slice(0, 1);
    const next = [...digits];
    next[index] = cleaned;
    onChange(next);
    if (cleaned && codeInputsRef.current[index + 1]) {
      codeInputsRef.current[index + 1].focus();
    }
  };

  const handleCodeKeyDown = (event, index) => {
    if (event.key === 'Backspace' && !digits[index] && codeInputsRef.current[index - 1]) {
      codeInputsRef.current[index - 1].focus();
    }
    if (event.key === 'ArrowLeft' && codeInputsRef.current[index - 1]) {
      codeInputsRef.current[index - 1].focus();
    }
    if (event.key === 'ArrowRight' && codeInputsRef.current[index + 1]) {
      codeInputsRef.current[index + 1].focus();
    }
  };

  const handleCodePaste = (event) => {
    const text = event.clipboardData.getData('text') || '';
    const pastedDigits = text.replace(/\D/g, '').slice(0, digits.length).split('');
    if (!pastedDigits.length) return;
    const next = [...digits];
    for (let i = 0; i < digits.length; i += 1) {
      next[i] = pastedDigits[i] || '';
    }
    onChange(next);
    const targetIndex = Math.min(pastedDigits.length, digits.length) - 1;
    if (targetIndex >= 0) {
      codeInputsRef.current[targetIndex]?.focus();
    }
    event.preventDefault();
  };

  return (
    <div className="code-inputs" onPaste={handleCodePaste}>
      {digits.map((digit, idx) => (
        <input
          key={idx}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={1}
          value={digit}
          ref={(el) => {
            codeInputsRef.current[idx] = el;
          }}
          onChange={(event) => handleCodeChange(idx, event.target.value)}
          onKeyDown={(event) => handleCodeKeyDown(event, idx)}
          className="code-input"
          aria-label={getAriaLabel ? getAriaLabel(idx) : undefined}
        />
      ))}
    </div>
  );
};

export default CodeInput;
